import Button from "components/general/buttonv2";
import { useState } from "react";
import styled from "styled-components";

export const StyledHeaderTitle = styled.h2`
  font-size: 3rem;
  line-height: 4.2rem;
  font-weight: 700;
  width: 100%;
  margin-bottom: 4rem;
  text-align: center;
  @media screen and (max-width: 1280px) {
    margin: 0 0 1rem 0;
  }
  @media screen and (max-width: 992px) {
    line-height: 1.5;
    font-size: 2.5rem;
  }
  @media screen and (max-width: 768px) {
    line-height: 1.5;
    font-size: 2rem;
    text-align: left;
  }
`;

export const StyledHeader = styled.div`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  background-color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 1280px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  display: flex;
  padding: 4rem 0;
  gap: 3rem;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
    padding: 2rem 0;
  }
  h2 {
    font-size: 2rem;
    line-height: 1.3;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 1.3;
  }
  h4 {
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;
const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledFaq = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`;
const StyledQuestion = styled.div`
  border-radius: 1rem;
  color: var(--text-color);
  padding: 1rem 2rem;
  font-weight: 700;
  cursor: pointer;
  gap: 1rem;
  display: flex;
  svg {
    height: auto;
    width: 1rem;
    fill: var(--text-color);
  }
`;
const StyledAnswer = styled.div`
  border-radius: 1rem;
  padding: 1rem 2rem;
`;
const StyledItem = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  border-radius: 6px;
  background: var(--raised-background-color);
`;

const MinusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21 11.75c0-.414-.336-.75-.75-.75h-16.5c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75z"
      fillRule="nonzero"
    />
  </svg>
);

const PlusSvg = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11 11h-7.25c-.414 0-.75.336-.75.75s.336.75.75.75h7.25v7.25c0 .414.336.75.75.75s.75-.336.75-.75v-7.25h7.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-7.25v-7.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"
      fillRule="nonzero"
    />
  </svg>
);

const FaqItem = ({ question, answer, hasLink }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <StyledItem>
      <StyledQuestion onClick={() => setExpanded((prev) => !prev)}>
        {expanded ? <MinusSvg /> : <PlusSvg />}
        <div>{question}</div>
      </StyledQuestion>
      {expanded && (
        <StyledAnswer>
          {answer}

          {hasLink && (
            <Button
              style={{ marginTop: "1rem" }}
              to="/services"
              buttonBuddy={true}
              dataAttr="hero-services"
            >
              Our services
            </Button>
          )}
        </StyledAnswer>
      )}
    </StyledItem>
  );
};

const BottomContent = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledBlock>
          <StyledHeaderTitle>FAQ</StyledHeaderTitle>
          <StyledFaq>
            <FaqItem
              question="My organization deals with sensitive information. Is using Redact secure?"
              answer=" Unlike similar services, Redact runs locally on your device. There are no logs or
                data sent to any servers or the cloud. No login data is gathered and any logs are
                optional, and are stored locally (they can be disabled or deleted at any time)."
            />
            <FaqItem
              question="What features are included for each platform?"
              answer="Take a look here for an overview of supported features for each platform."
              hasLink={true}
            />

            <FaqItem
              question="Can my employees use this service?"
              answer="Yes, we can bundle any number of personal licenses with Redact Pro, so your
              employees can stay safe online."
            />

            <FaqItem
              question="Is there anything Redact Pro cannot delete?"
              answer="Anything that you can natively delete is supported by Redact Pro."
            />

            <FaqItem
              question="My organization wants a feature that is not yet included."
              answer="We are actively developing new features, but if there are any specific features you
              require, please let us know! We can build out any number of custom features."
            />
          </StyledFaq>
        </StyledBlock>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default BottomContent;
